import Vue from "vue";
import axios from "axios";
import Article from "@/clas/Article";
import { EventBus } from "@/main";

const state = {
    articles:
        JSON.parse(localStorage.getItem("pacart")) !== undefined &&
        JSON.parse(localStorage.getItem("pacart")) != null
            ? JSON.parse(localStorage.getItem("pacart"))
            : [],
};

const getters = {
    getSubTotal: (state) => {
        var subTotal = 0;
        let a = new Article();

        state.articles.forEach((article) => {
            a.setArticle(article);

            subTotal = subTotal + a.price() * article.amount;
        });

        return subTotal;
    },

    getDiscount: (state, getters, rootState) => {
        if (rootState.authenticated) {
            return (
                (getters.getSubTotal / 100) *
                rootState.acount.user.customer.discount
            );
        }
        return 0;
    },

    getIva: (state, getters) => {
        return (getters.getSubTotal - getters.getDiscount) * 0.16;
    },

    getTotal: (state, getters) => {
        return getters.getSubTotal - getters.getDiscount + getters.getIva;
    },

    getWeight: (state, getters) => {
        let weight = 0;

        state.articles.forEach((article) => {
            weight = weight + article.weight * article.amount;
        });

        return Math.round(weight);
    },

    getArticles: (state) => state.articles,
};

const mutations = {
    SET_ARTICLES(state, articles) {
        state.articles = articles;
        localStorage.setItem("pacart", JSON.stringify(state.articles));
    },

    PUSH_ARTICLE(state, article) {
        state.articles.push(article);
        localStorage.setItem("pacart", JSON.stringify(state.articles));
    },

    UPDATE_ARTICLES(state, articles) {
        state.articles = Object.assign([], articles);

        localStorage.setItem("pacart", JSON.stringify(state.articles));
    },

    REMOVE_ARTICLE(state, article) {
        let indexOf = state.articles.indexOf(
            state.articles.find((item) => item.id === article.id)
        );

        state.articles.splice(indexOf, 1);

        localStorage.setItem("pacart", JSON.stringify(state.articles));
    },

    CLEAR(state) {
        state.articles = [];
        localStorage.setItem("pacart", JSON.stringify(state.articles));
    },

    LS_STORE(state) {
        localStorage.setItem("pacart", JSON.stringify(state.articles));
    },
};

const actions = {
    productCartAdd({ dispatch, commit, state }, article) {
        article = {
            id: article.id,
            code: article.code,
            color: article.color
                ? {
                      name: article.color.name,
                      hex: article.color.hex,
                  }
                : null,
            price: article.price,
            weight: article.weight,
            amount: article.amount,
            images: article.images,
            discount: article.discount,
            product_id: article.product_id,
            description: article.description,
            box_capacity: article.box_capacity,
            type_of_finish: article.type_of_finish
                ? {
                      id: article.type_of_finish.id,
                      name: article.type_of_finish.name,
                  }
                : null,
        };

        let item = state.articles.find((item) => item.id == article.id);

        if (item) {
            if (
                !confirm(
                    `Ya cuenta con ${item.amount} unidades de este artículo en su carrito.\n¿Quiere sumar ${article.amount} unidades mas?`
                )
            ) {
                return 0;
            }

            dispatch("cartArticleUpdate", {
                ...item,
                amount: parseInt(item.amount) + parseInt(article.amount),
            });
        } else {
            commit("PUSH_ARTICLE", article);
        }

        EventBus.$emit("Snackbar", {
            text: "Artículo agregado al carrito.",
            type: "success",
            timeout: 2000,
        });

        EventBus.$emit("ArticleAdded");
    },

    cartArticleUpdate({ commit, state }, article) {
        let articles = state.articles;

        let indexOf = state.articles.indexOf(
            state.articles.find((item) => item.id === article.id)
        );

        articles[indexOf] = article;

        commit("UPDATE_ARTICLES", articles);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
